import moment from 'moment-timezone';
import { useQuery } from 'react-query';

import { highLevelProgram as queryFn } from 'api/endPoints/highLevelProgram';
import { QueryKeys } from 'api/queryKeys';

import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

export const useQueryHighLevelProgram = (params: QueryParams) => {
    return useQuery<QueryFnResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['highLevelProgram', params],
        queryFn: () => queryFn(params),
        enabled: params.id.length > 0 && params.id.filter((item) => item).length > 0,
        select: (data) => {
            const nowDate = moment(data.nowDate || '201010').toDate();
            return {
                data: data.wbs,
                info: data.info,
                nowDate: nowDate,
            };
        },
    });
};

export interface QueryParams {
    id: string[];
    filter: { filters: IFilter[] | undefined };
}

interface QueryFnResponse {
    info: IToolTip;
    nowDate: Date;
    wbs: {
        actualEndDate: null;
        actualStartDate: number;
        color: string;
        description: string;
        'duration%Complete': number;
        level: number;
        plannedEndDate: number;
        plannedStartDate: number;
        taskCode: string;
    }[];
}

export type QueryResponse = {
    info: IToolTip;
    nowDate: Date;
    data: {
        actualEndDate: null;
        actualStartDate: number;
        color: string;
        description: string;
        'duration%Complete': number;
        level: number;
        plannedEndDate: number;
        plannedStartDate: number;
        taskCode: string;
    }[];
};
